import { render, staticRenderFns } from "./report31.vue?vue&type=template&id=636fc159&scoped=true"
import script from "./report31.vue?vue&type=script&lang=js"
export * from "./report31.vue?vue&type=script&lang=js"
import style0 from "./report31.vue?vue&type=style&index=0&id=636fc159&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636fc159",
  null
  
)

export default component.exports